import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHead from "./SectionHead";

export default function CategorySection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
      <SectionHead
        eyebrow="漫画分类"
        title="想看哪部，直接搜"
        desc="热血冒险、奇幻仙侠、都市生活、校园青春……按分类快速找到你喜欢的连载漫画。"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7">
        {categories.map((c, i) => (
          <Link
            key={c.id}
            to={`/list?category=${c.id}`}
            className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-6 text-center transition-all hover:-translate-y-1 hover:border-primary-300"
          >
            <span
              className={`flex h-12 w-12 items-center justify-center rounded-xl ${
                i % 3 === 0
                  ? "bg-primary-100 text-primary-600"
                  : i % 3 === 1
                    ? "bg-accent-100 text-accent-600"
                    : "bg-secondary-100 text-secondary-700"
              }`}
            >
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <div>
              <p className="text-sm font-bold text-foreground-900">{c.name}</p>
              <p className="mt-1 text-xs text-foreground-500">{c.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}